/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ClipsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABmElEQVR4nNWVPyhFcRTHr/9F+TcaDIxIRqJnoK7u7/x58nvnvEfJ8mxGZXqZmCwGZZTNxGBhsiijnUEkyqYU+dPvPcm999HDK/zqLOf8zvdzft9z63reXzu5XK6SWToRUyPW2iqXM5zuR9JLZN0PkqneL4v6vl+HpKtIeoQst8j6jCR31tomV0fS3Xwun9dra21rUSHD6UFgWQHWPWA9I8r0uDxRevZN4DWAZC0vjtqHrE+hGks2Jg6ki+FLematrU0kEtVIchIBPATjmY58H8tWEfh6eHJj211T6GJS5wrTSyYuoJuu5nYBJI/vaqfAsoOoEyEAkQxHJrgyxtR7nlcBLMeR2n2QTHUX+qabEVMzRDLg+5ONHy4RQLsi9iy4fBBkWoD1AFk3gHTesIwhatuXv5JsNluDpIfAsu12MTo61eD9uwOkN9FlfjecVgxQLnF8jd8FEMlAKbYaTg9+C+AaSwEQydDftAh/YwfmE7/LsgP6xO+SAMByUUaLzou9YLlcACBdigHcz8VBfvISKPQuO60Y4N+eFx4QRPGJdI6JAAAAAElFTkSuQmCC)
 */
export const ClipsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.74 5.74a.5.5 0 0 0 .54.7l5.01-.88a.5.5 0 0 0 .4-.58l-.26-1.47a3 3 0 0 0-3.2-2.47.46.46 0 0 0-.37.26l-2.12 4.44ZM15.13 2.37a.5.5 0 0 0-.53-.7l-4.25.74a.5.5 0 0 0-.37.28L7.87 7.13a.5.5 0 0 0 .53.7l4.25-.74a.5.5 0 0 0 .37-.28l2.11-4.44ZM6.72 3.05l-2.55.45a3 3 0 0 0-2.43 3.48L2 8.46c.05.27.3.45.58.4l2.2-.39a.5.5 0 0 0 .36-.27l2.12-4.44a.5.5 0 0 0-.54-.7Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2 10.5c0-.28.22-.5.5-.5h19c.28 0 .5.22.5.5V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8.5ZM5 14a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H6Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
